import cx from 'classnames';

import { IInlineFormFieldProps } from './types';

export const InlineFormField = ({
  title,
  value,
  children,
  bottomBorder = true,
  className = 'py-3',
}: IInlineFormFieldProps) => (
  <div
    className={cx(
      'w-full flex flex-col 2xl:flex-row items-start 2xl:items-center justify-between',
      { 'border-b border-border-medium': bottomBorder },
      className,
    )}
  >
    <span className="typography-title-3 text-text-tertiary mb-1 2xl:mb-0 2xl:mr-2">{title}</span>

    {(value || children) && (
      <div className="flex flex-col items-start 2xl:items-end 2xl:text-right">
        {value && (
          <span className="typography-inline-highlight-3 text-text-primary" title={value.toString()}>
            {value}
          </span>
        )}

        {children}
      </div>
    )}
  </div>
);
